import { jobLists } from "character";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import { quests } from "data-files/quests";
import { shops } from "data-files/shops";
import { EorzeaDataType, GameData, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewWeaponEurekaAntiquatedProps } from "views/relics/weapons/eureka/antiquated/types";
import "./WeaponEurekaAntiquated.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class WeaponEurekaAntiquated extends Component<ViewWeaponEurekaAntiquatedProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
		type: RelicData.Type.WEAPON,
		relic: RelicData.Group.WEAPON_EUREKA,
		part: RelicData.Part.WEAPON_ANTIQUATED,
		steps: [RelicData.Step.ANTIQUATED],
		stepPlaceholders: {},
		next: {
			part: RelicData.Part.WEAPON_ANEMOS,
			view: View.RELIC_WEAPONS_EUREKA_ANEMOS,
		},
		previous: null,
	};

	constructor(props:ViewWeaponEurekaAntiquatedProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		return (
			<div id="weapon-eureka-antiquated" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.ANTIQUATED} id={RelicData.Step.ANTIQUATED} stepComplete={completeSteps[RelicData.Step.ANTIQUATED]}>
						<p>{t.t("Rewarded from level 70 job quest - If you have lost or discarded it, you can purchase a replacement for 1,000 Gil from any of the following")}</p>
						<p><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.SHOP} lodestoneID={shops[GameData.Shop.CALAMITY_SALVAGER_LIMSA].lodestoneID} text={GameData.Shop.CALAMITY_SALVAGER_LIMSA} /></p>
						<p><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.SHOP} lodestoneID={shops[GameData.Shop.CALAMITY_SALVAGER_GRIDANIA].lodestoneID} text={GameData.Shop.CALAMITY_SALVAGER_GRIDANIA} /></p>
						<p><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.SHOP} lodestoneID={shops[GameData.Shop.CALAMITY_SALVAGER_ULDAH].lodestoneID} text={GameData.Shop.CALAMITY_SALVAGER_ULDAH} /></p>
					</DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		return [
			{ type: quests[GameData.Quest.STORMBLOOD].type, text: GameData.Quest.STORMBLOOD, lodestoneID: quests[GameData.Quest.STORMBLOOD].lodestoneID },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [];
	}
}
export default connect(mapStateToProps)(WeaponEurekaAntiquated);
